import * as React from 'react';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';
import SalePrintResult from '../../containers/sales/SalePrintResult';

type Props = {
  onReturn: any,
}

type State = {}

class SalePrint extends React.Component<Props, State> {

  onClose = () => {
    const { onReturn } = this.props;
    if (onReturn) onReturn();
  };

  render() {
    const { onReturn } = this.props;

    return (
      <Overlay onClick={this.onClose}>
        <SideModal>
          <Head headTitle={'Printing Status'} />
          <SideModalContent>
            <SalePrintResult
              onReturn={onReturn}
            />
          </SideModalContent>
        </SideModal>
      </Overlay>
    );
  }
}

export default SalePrint as any;
